var _g, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.373 47.0002C54.373 36.4126 49.0912 27.8296 42.5757 27.8296H51.4237C57.939 27.8296 63.221 36.4126 63.221 47.0002C63.221 57.588 57.939 66.1709 51.4237 66.1709H42.5757C49.0912 66.1709 54.373 57.588 54.373 47.0002Z",
    fill: "#D7E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.373 47.0002C54.373 36.4126 49.0912 27.8296 42.5757 27.8296H51.4237C57.939 27.8296 63.221 36.4126 63.221 47.0002C63.221 57.588 57.939 66.1709 51.4237 66.1709H42.5757C49.0912 66.1709 54.373 57.588 54.373 47.0002Z",
    stroke: "black",
    strokeWidth: 5.04335,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5756 66.1709C45.7045 66.1709 48.7052 64.1511 50.9176 60.556C53.13 56.9608 54.3729 52.0846 54.3729 47.0003C54.3729 41.9159 53.13 37.0398 50.9176 33.4446C48.7052 29.8494 45.7045 27.8296 42.5756 27.8296C39.4468 27.8296 36.4461 29.8494 34.2337 33.4446C32.0212 37.0398 30.7783 41.9159 30.7783 47.0003C30.7783 52.0846 32.0212 56.9608 34.2337 60.556C36.4461 64.1511 39.4468 66.1709 42.5756 66.1709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5756 66.1709C45.7045 66.1709 48.7052 64.1511 50.9176 60.556C53.13 56.9608 54.3729 52.0846 54.3729 47.0003C54.3729 41.9159 53.13 37.0398 50.9176 33.4446C48.7052 29.8494 45.7045 27.8296 42.5756 27.8296C39.4468 27.8296 36.4461 29.8494 34.2337 33.4446C32.0212 37.0398 30.7783 41.9159 30.7783 47.0003C30.7783 52.0846 32.0212 56.9608 34.2337 60.556C36.4461 64.1511 39.4468 66.1709 42.5756 66.1709Z",
    stroke: "black",
    strokeWidth: 5.04335,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.373 47H63.221",
    stroke: "black",
    strokeWidth: 5.04335,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5298 57.3228H61.3318",
    stroke: "black",
    strokeWidth: 5.04335,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5298 36.6777H61.3318",
    stroke: "black",
    strokeWidth: 5.04335,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 44.2885,
    stroke: "white",
    strokeWidth: 5.42308
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.3846,
    height: 43.3846,
    fill: "white",
    transform: "translate(25.3076 25.3076)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBet);
export default __webpack_public_path__ + "static/media/bet.d8475e88a35c666fcb90bf9e5e2e2343.svg";
export { ForwardRef as ReactComponent };